import { ThemeProvider } from '@mui/material/styles';
import { primaryTheme } from '../../../provider/themeProvider';

import { LandingMainContainer } from '../components';
import { LandingFallbackComponent } from '../components/LandingFallbackComponent/LandingFallbackComponent';
import { useDesktopMediaQuery } from '../../../hooks/useDesktopMediaQuery';

export const FallbackPage = () => {
  const { matchesMD } = useDesktopMediaQuery();
  return (
    <ThemeProvider theme={primaryTheme}>
      <LandingMainContainer>
        <LandingFallbackComponent matchesMD={matchesMD} />
      </LandingMainContainer>
    </ThemeProvider>
  );
};
